import { getStudent } from '@/game/GameComponents/PhaserGame/GameInstance';
import { EventBus } from '../EventBus';
import GAME_EVENTS from '../Utils/gameEventsDef';
import { getBiomeFromStudentLevel } from '../Utils/PhaserUtils';

export interface TutorializationManagerData {
  scene: Phaser.Scene;
  cutscene: string;
}

export interface CutsceneData {
  id?: string;
  characterSprite?: string; // refers to the npc
  slides: CutsceneSlide[];
}

export type SoundCard = string; // s, ch, etc

export interface CutsceneSlide {
  mainImage: string; // refers to the character image - can change to add psuedo animation
  mainText: string;
  speakerAnimationKey: string;
  audioKey: string;
  cards?: SoundCard[];
}

// Handles game tutorialization, such as showing guidance arrows, performing tutorial dialogue/cutscenes etc.
export default class TutorializationManager {
  scene: Phaser.Scene;
  cutscene: string;

  constructor(data: TutorializationManagerData) {
    this.scene = data.scene;
    this.cutscene = data.cutscene;
  }

  RunLevelMapTutorialization() {
    const student = getStudent();

    // Assessment
    // if (student.assessmentId) {
    //   // Start the assessment scene.
    //   this.scene.scene.pause('LevelMap');
    //   this.scene.scene.pause(LevelMap.TILEMAP_ID);
    //   this.scene.scene.launch('Assessment');
    //   this.scene.scene.launch('AssessmentUI');
    // }

    // NPC Guidance arrow.
    const studentLevel = student.level;

    // Show guidance arrow if no games are completed and the player is level 1.
    const levelsProgress = student.levelsProgress;
    const noGamesCompleted = Object.values(levelsProgress[0].gamesProgress);
    let shouldShowNPCGuidanceArrow = studentLevel === 1 && noGamesCompleted;
    shouldShowNPCGuidanceArrow = false; // Temp - we don't need guidance.

    if (shouldShowNPCGuidanceArrow) {
      let guidanceArrow = this.scene.add
        .sprite(0, -65, 'guidance-arrow')
        .setScale(0.5)
        .setDepth(10)
        .play('guidance-arrow-idle');

      // Find the first NPC in the scene and assign the guidance arrow to them.
      const npcs = this.scene.children.getAll('name', 'NPCRoot');
      (npcs[0] as Phaser.GameObjects.Container)?.add(guidanceArrow);
    }

    const biome = getBiomeFromStudentLevel(student.level);

    if (
      student.tutorialization.biomesVisited.filter(
        (visitedBiome: number) => visitedBiome === biome,
      ).length === 0
    ) {
      EventBus.emit(GAME_EVENTS.ENTERED_NEW_BIOME, biome);
      // Do mentor introduction for first time in new biome.
    }

    // Show level cutscene.
    const shouldShowLevelCutscene = false;
    // temporarily disable cutscene.
    if (shouldShowLevelCutscene) {
      // const scriptData = ScriptDataRaw as ScriptData;
      // const ssData = ScopeAndSequence;
      // const studentLevel = getGameInstance().student.level;
      // const thisLevelData = ssData.data.find((datum) => {
      //   return datum.level === studentLevel;
      // });
      // if (!thisLevelData) return;
      // const ssLevelId = thisLevelData.id;
      // const tierKey = `tier_${getBiomeFromStudentLevel(studentLevel) + 1}`;
      // const explanation =
      //   scriptData[tierKey as keyof ScriptData][`${ssLevelId}`].explanation;
      // const thisCutsceneData = { slides: [explanation] };
      // const guide = new TutorialGuide({
      //   scene: this.scene,
      //   cutsceneData: thisCutsceneData,
      // });
      // guide.body.on('pointerdown', () => {
      //   this.RunLevelCutscene(thisCutsceneData);
      // });
      // this.RunLevelCutscene(thisCutsceneData);
    }

    return this;
  }
}
